import { copyToClipboard } from "../../Helpers/ValueHandlers/copyText";

interface CopyPhoneProps {
    phoneNumber: string;
    marginLeft?: string;
}

export default function CopyPhone({ phoneNumber, marginLeft = '2px' }: CopyPhoneProps) {
    if (!phoneNumber) {
        return null;
    }

    return (
        <span
            onClick={() => copyToClipboard(phoneNumber)}
            style={{ cursor: 'pointer', marginLeft }}
            title={`Copy phone number: ${phoneNumber}`}
        >
            📞
        </span>
    );
}
